"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5287],{

/***/ 52900:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ apartments; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(43291);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(57239);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(23097);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(33616);
// EXTERNAL MODULE: ./node_modules/next-translate/lib/esm/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(89136);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(60123);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(46572);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./components/atoms/container/index.ts + 1 modules
var container = __webpack_require__(82112);
// EXTERNAL MODULE: ./components/atoms/section-text/index.ts
var section_text = __webpack_require__(67526);
// EXTERNAL MODULE: ./components/atoms/link/index.ts + 1 modules
var atoms_link = __webpack_require__(27594);
// EXTERNAL MODULE: ./components/molecules/swiper-custom/index.ts + 1 modules
var swiper_custom = __webpack_require__(6306);
// EXTERNAL MODULE: ./components/organisms/apartment-card/index.ts + 1 modules
var apartment_card = __webpack_require__(92993);
;// CONCATENATED MODULE: ./components/templates/apartments/Apartments.tsx










var Tabs = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 37195));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(37195)
            ];
        }
    }
});
/**
 * Apartments
 */ var Apartments = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, apartments = param.apartments, backgroundColorBottom = param.backgroundColorBottom, backgroundColorTop = param.backgroundColorTop, caption = param.caption, _cutLevel = param.cutLevel, cutLevel = _cutLevel === void 0 ? 50 : _cutLevel, desc = param.desc, title = param.title, link = param.link, _cutLevelMobile = param.cutLevelMobile, cutLevelMobile = _cutLevelMobile === void 0 ? 50 : _cutLevelMobile, textColor = param.textColor, index = param.index, id = param.id, _monthday = param.monthday, monthday = _monthday === void 0 ? "Month" : _monthday, hasCutLevel = param.hasCutLevel;
    var ref, ref1, ref2;
    var t = (0,useTranslation/* default */.Z)("common").t;
    var tabsName = [
        t("prices.priceMonth"),
        t("prices.priceDay")
    ];
    var apartmentsMonth = apartments === null || apartments === void 0 ? void 0 : (ref = apartments.apartmentsCards) === null || ref === void 0 ? void 0 : ref.filter(function(itm) {
        return itm.tipoestancia === "month";
    });
    var apartmentsDay = apartments === null || apartments === void 0 ? void 0 : (ref1 = apartments.apartmentsCards) === null || ref1 === void 0 ? void 0 : ref1.filter(function(itm) {
        return itm.tipoestancia !== "month";
    });
    var longitud = apartmentsDay.length + apartmentsMonth.length;
    var isApartments = "apartments" === "apartments";
    //Cutlevel y cutlevelmobile están intercambiados por alguna razón, no he encontrado la causa, pero con invertirlos aquí es suficiente. SI te animas buena suerte con ello, en el resto de componentes funciona normal
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(container/* default */.Z, {
        index: index,
        backgroundColorTop: backgroundColorTop !== null && backgroundColorTop !== void 0 ? backgroundColorTop : "#fff",
        backgroundColorBottom: backgroundColorBottom !== null && backgroundColorBottom !== void 0 ? backgroundColorBottom : "#fff",
        cutLevel: cutLevelMobile === null ? 50 : cutLevelMobile,
        cutLevelMobile: cutLevel === null ? 50 : cutLevel,
        backgroundColorBottomMobile: backgroundColorBottom,
        backgroundColorTopMobile: backgroundColorTop,
        hasCutLevel: hasCutLevel,
        overflows: true,
        className: "".concat(isApartments ? "flex-col" : "flex-col ".concat(longitud > 1 ? "md:flex-row" : ""), "  flex gap-10 ").concat(className),
        id: id,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(section_text/* default */.Z, {
                title: title,
                directionMobile: "column",
                desc: desc,
                caption: caption,
                direction: longitud > 1 ? "row" : "column",
                textAlign: "start",
                className: " ".concat(longitud > 1 ? "" : "w-full md:max-w-[33%]"),
                variant: textColor,
                overflows: true
            }),
            apartmentsMonth.length > 0 && apartmentsDay.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Tabs, {
                tabsName: tabsName,
                type: "default",
                selectedAtFirst: 0,
                cardRotation: true,
                overflows: true,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_custom["default"], {
                        scrollbar: true,
                        navigation: true,
                        slidesPerView: longitud > 1 ? 3 : 1,
                        slidesPerViewTablet: longitud > 1 ? 2.2 : 1,
                        slidesPerViewMobile: longitud > 1 ? 1.2 : 1,
                        gap: 24,
                        overflows: true,
                        children: apartmentsMonth === null || apartmentsMonth === void 0 ? void 0 : apartmentsMonth.map(function(apartmentsCards, index) {
                            return /*#__PURE__*/ (0,react.createElement)(apartment_card/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, apartmentsCards), {
                                key: index,
                                monthday: "Month",
                                className: "h-full"
                            }));
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_custom["default"], {
                        scrollbar: true,
                        navigation: true,
                        slidesPerView: longitud > 1 ? 3 : 1,
                        slidesPerViewTablet: longitud > 1 ? 2.2 : 1,
                        slidesPerViewMobile: longitud > 1 ? 1.2 : 1,
                        gap: 24,
                        overflows: true,
                        children: apartmentsDay === null || apartmentsDay === void 0 ? void 0 : apartmentsDay.map(function(apartmentsCards, index) {
                            return /*#__PURE__*/ (0,react.createElement)(apartment_card/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, apartmentsCards), {
                                key: index,
                                monthday: "Day",
                                className: "h-full"
                            }));
                        })
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat(longitud > 1 ? "" : "h-full w-full md:max-w-[66%]"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_custom["default"], {
                    scrollbar: true,
                    navigation: true,
                    slidesPerView: longitud > 1 ? 3 : 1,
                    slidesPerViewTablet: longitud > 1 ? 2.2 : 1,
                    slidesPerViewMobile: longitud > 1 ? 1.2 : 1,
                    gap: 24,
                    className: "".concat(longitud > 1 ? "" : " h-full"),
                    children: (ref2 = apartmentsMonth || apartmentsDay) === null || ref2 === void 0 ? void 0 : ref2.map(function(apartmentsCards, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(apartment_card/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, apartmentsCards), {
                            monthday: monthday,
                            cardOrientation: isApartments || longitud > 1 ? "column" : "row",
                            buttonWidth: 100,
                            className: "h-full"
                        }), index);
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: (link === null || link === void 0 ? void 0 : link.link) && (link === null || link === void 0 ? void 0 : link.text) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex !w-full max-w-[calc(100%-1.25rem)] justify-center md:max-w-wrapper md:mx-0 md:justify-end md:px-5 lg:px-0 xl:max-w-[calc(var(--wrapper-size)-2.5rem)]",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        passHref: true,
                        prefetch: false,
                        href: link.link,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_link/* default */.Z, {
                            arrow: true,
                            as: "a",
                            variant: link === null || link === void 0 ? void 0 : link.variant,
                            children: link.text
                        })
                    })
                })
            })
        ]
    });
};
Apartments.displayName = "Apartments";

;// CONCATENATED MODULE: ./components/templates/apartments/index.ts

/* harmony default export */ var apartments = (Apartments);


/***/ })

}]);